import { ActiveStatus } from '../../../billing-tool/utils/contract-utils';

export enum SubscriptionEstimateColumnFields {
  GROSS = 'gross',
  RESERVE = 'reserve',
  NET = 'net',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
  STATUS = 'status',
  LAST_MODIFIED = 'lastModified',
  ACTIONS = 'actions',
}

export enum SubscriptionEstimateColumnHeaderNames {
  GROSS = 'Gross',
  RESERVE = 'Reserve',
  NET = 'Net',
  START_DATE = 'Start Date',
  END_DATE = 'End Date',
  STATUS = 'Status',
  LAST_MODIFIED = 'Last Modified',
  ACTIONS = 'Actions',
}

export const SUBSCRIPTION_ESTIMATES_EDIT_ACTION_TEST_ID =
  'subscription-estimates-edit-action';

export const SUBSCRIPTION_ESTIMATES_ADD_BUTTON_TEST_ID =
  'subscription-estimates-add-button';

export const SUBSCRIPTION_ESTIMATES_STATUS_FILTER_TEST_ID_PREFIX =
  'subscription-estimates-status-filter';

export type SubscriptionEstimateStatusFilter =
  | 'all'
  | ActiveStatus.Active
  | ActiveStatus.Past
  | ActiveStatus.Future;

export const SUBSCRIPTION_ESTIMATE_FORM_TEST_ID = 'subscription-estimate-form';
export const SUBSCRIPTION_ESTIMATE_FORM_GROSS_INPUT_TEST_ID =
  'subscription-estimate-form-gross-input';
export const SUBSCRIPTION_ESTIMATE_FORM_RESERVE_INPUT_TEST_ID =
  'subscription-estimate-form-reserve-input';
export const SUBSCRIPTION_ESTIMATE_FORM_NET_DISPLAY_TEST_ID =
  'subscription-estimate-form-net-display';
export const SUBSCRIPTION_ESTIMATE_FORM_START_DATE_INPUT_TEST_ID =
  'subscription-estimate-form-start-date-input';
export const SUBSCRIPTION_ESTIMATE_FORM_END_DATE_INPUT_TEST_ID =
  'subscription-estimate-form-end-date-input';
export const SUBSCRIPTION_ESTIMATE_FORM_SUBMIT_TEST_ID =
  'subscription-estimate-form-submit-button';
export const SUBSCRIPTION_ESTIMATE_FORM_CANCEL_TEST_ID =
  'subscription-estimate-form-cancel-button';
export const SUBSCRIPTION_ESTIMATE_FORM_PERIOD_ERROR_TEST_ID =
  'subscription-estimate-form-period-error';

/**
 * Row view-model for the subscription-estimate grid. One row per
 * SubscriptionEstimateType, with derived display fields resolved up front so the
 * grid columns stay presentational.
 */
export interface SubscriptionEstimateRow {
  id: number;
  grossAmount: number;
  reserveAmount: number;
  /** grossAmount + reserveAmount (reserve stored negative), displayed positive. */
  netAmount: number;
  startDate: string;
  endDate: string | null;
  status: ActiveStatus;
  /** "F. Last", or the raw lastModifiedBy on unexpected formats. */
  lastModifiedDisplay: string;
  updatedAt: string;
}
